// extracted by mini-css-extract-plugin
export var fadeIn = "_1p-0";